import { Button } from '@/components/Elements';
import { InputField } from '@/components/Form';
import { useRegister } from '@/lib/auth';
import { isAxiosError } from 'axios';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { InformationCircleIcon } from '@heroicons/react/16/solid';

export const RegistrationMailOnlyForm = () => {
  const [isUnprocessableContentError, setUnprocessableContentError] =
    useState<boolean>(false);

  const emailRef = useRef<HTMLInputElement>(null);
  const { t } = useTranslation();
  const register = useRegister();

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // 重複送信防止: 送信中状態の確認
    if (register.isPending) return;

    if (!emailRef.current) return;
    register.mutate(
      {
        email: emailRef.current.value,
        confirmSuccessUrl: window.location.origin + '/setup/profile',
        isTermsAgreed: true, // 期限切れの再登録なので、既に同意済みとして扱う
      },
      {
        onSuccess: () => {
          window.location.href =
            window.location.origin + '/auth/register/complete';
        },
        onError: () => {
          if (
            isAxiosError(register.error) &&
            register.error.response &&
            register.error.response.status >= 400
          ) {
            setUnprocessableContentError(true);
          }
        },
      }
    );
  };

  return (
    <form className="space-y-6" onSubmit={onSubmit}>
      <InputField
        ref={emailRef}
        label={t('メールアドレス')}
        type="email"
        autoComplete="email"
        placeholder={t('メールアドレスを入力...')}
        required
      />
      {isUnprocessableContentError && (
        <div className="flex items-center text-sm text-red-600">
          <InformationCircleIcon className="mr-0.5 size-4" />
          {t('登録できないメールアドレスです。')}
        </div>
      )}

      <Button
        type="submit"
        size="sm"
        className="w-full"
        disabled={register.isPending}
        isLoading={register.isPending}
      >
        {t('招待メールを受け取る')}
      </Button>
    </form>
  );
};
